import type { StyleRule } from '@archipro-design/aria';
import { pxArrayToRem } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const TagContainer: StyleRule = () => ({
    gap: pxArrayToRem([50, 6]),
    marginBottom: pxToRem(31),
});

export const TagsScrollableContainer: StyleRule = () => ({
    marginTop: pxToRem(24),
});
